import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch } from "react-redux";
import { UPDATE_TAX } from "../../store/cart/cartActionTypes";
import { connect } from "react-redux";
import { Helmet } from "react-helmet-async";
import { Redirect } from "react-router-dom";
import Currency from "../shared/Currency";
import PageHeader from "../shared/PageHeader";
import { loadStripe } from "@stripe/stripe-js";
import { toast } from "react-toastify"; // Importer react-toastify
import api from "../../api/api";
import theme from "../../data/theme";

const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_KEY
);

const ShopPageCheckout = (props) => {
    const { cart, user } = props;

  const  dispatch =  useDispatch()

    const curentUser = user.userConnected.user;
    const [shippingInfo, setShippingInfo] = useState({
        payment: "bank",
        loading: false || "",
        errorMessage: null || "",
        shippingAddress1: curentUser?.streetAddress || "",
        apartment: curentUser?.apartment || "",
        city: curentUser?.city || "",
        zip: curentUser?.zip || "",
        province: curentUser?.province || "QC",
        country: curentUser?.country || "",
        phone: curentUser?.phone || "",
        email: curentUser?.email || "",
        firstName: curentUser?.firstName || "",
        lastName: curentUser?.lastName || "",
        companyName: curentUser?.companyName || "",
        taxAmount: 0,
    });


    const handleChange = (e) => {
        const { id, value } = e.target;
        setShippingInfo((prevState) => ({
            ...prevState,
            [id]: value,
        }));
    };

    useEffect(() => {
        const taxRates = {
            AB: 0.05,
            BC: 0.12,
            MB: 0.12,
            NB: 0.15,
            NL: 0.15,
            NS: 0.15,
            ON: 0.13,
            PE: 0.15,
            QC: 0.14975,
            SK: 0.11,
        };

        const province = shippingInfo.province;
        const taxRate = taxRates[province] || 0;
        const orderTotal = cart.subtotal * taxRate;

        setShippingInfo((prevState) => ({
            ...prevState,
            taxAmount: orderTotal,
        }));

        dispatch({
            type: UPDATE_TAX,
            newTax: orderTotal,
        });
    }, [shippingInfo.province, cart.subtotal, dispatch]);

    const validateForm = () => {
        const { lastName, firstName, shippingAddress1, city, zip, province, country, phone } = shippingInfo;

        if (!lastName || !firstName || !shippingAddress1 || !city || !zip || !country || !phone || !province) {
            return false;
        }
        return true;
    };

    const handlePlaceOrder = async (event) => {
        event.preventDefault();

        if (!validateForm()) {
            toast.error("Please fill in all required fields.", { theme: "colored" });
            return;
        }

        setShippingInfo({ loading: true, errorMessage: null });

        try {
            const response = await api.post("payment/create-checkout-session", {
                name: shippingInfo.name,
                shippingAddress1: shippingInfo.shippingAddress1,
                apartment: shippingInfo.apartment,
                city: shippingInfo.city,
                zip: shippingInfo.zip,
                province: shippingInfo.province,
                companyName: shippingInfo.companyName,
                country: shippingInfo.country,
                phone: shippingInfo.phone,
                email: user?.userConnected?.user?.email || shippingInfo.email,
                user: user?.userConnected.user?.id,
                items: cart.items.map((item) => ({
                    name: item.product.name,
                    amount: item.price,
                    currency: "cad",
                    quantity: item.quantity,
                    productId: item.product.id,
                })),
                taxAmount : shippingInfo.taxAmount
            });

            console.log(response, "response");

            const { id: sessionId } = response.data;

            console.log(sessionId, "sessionId");

            const stripe = await stripePromise;

            const { error } = await stripe.redirectToCheckout({ sessionId });

            if (error) {
                setShippingInfo({ errorMessage: error.message });
            }
        } catch (error) {
            setShippingInfo({ errorMessage: error.message });
        } finally {
            setShippingInfo({ loading: false });
        }
    };

    const renderTotals = () => {
        if (cart.extraLines.length <= 0) {
            return null;
        }

        const extraLines = cart.extraLines.map((extraLine, index) => (
            <tr key={index}>
                <th>{extraLine.title}</th>
                <td>
                    <Currency value={extraLine.price} />
                </td>
            </tr>
        ));

        return (
            <React.Fragment>
                <tbody className="checkout__totals-subtotals">
                    <tr>
                        <th>Subtotal</th>
                        <td>
                            <Currency value={cart.subtotal} />
                        </td>
                    </tr>
                    {extraLines}
                </tbody>
            </React.Fragment>
        );
    };

    const renderCart = () => {
        const items = cart.items.map((item) => (
            <tr key={item.id}>
                <td>{`${item.product.name} × ${item.quantity}`}</td>
                <td>
                    <Currency value={item.total} />
                </td>
            </tr>
        ));

        return (
            <table className="checkout__totals">
                <thead className="checkout__totals-header">
                    <tr>
                        <th>Product</th>
                        <th>Total</th>
                    </tr>
                </thead>
                <tbody className="checkout__totals-products">{items}</tbody>
                {cart.extraLines.length > 0 && renderTotals()}
                <tfoot className="checkout__totals-footer">
                    <tr>
                        <th>Total</th>
                        <td>
                            <Currency value={cart.total} />
                        </td>
                    </tr>
                </tfoot>
            </table>
        );
    };

    const { loading, errorMessage } = shippingInfo;

    if (cart.items.length < 1) {
        return <Redirect to="cart" />;
    }

    const breadcrumb = [
        { title: <FormattedMessage id="header.home" defaultMessage="Home" />, url: "" },
        { title: <FormattedMessage id="header.shoppingCart" defaultMessage="Shopping Cart" />, url: "/shop/cart" },
        { title: <FormattedMessage id="header.checkout" defaultMessage="Checkout" />, url: "" },
    ];

    return (
        <React.Fragment>
            <Helmet>
                <title>{`Checkout — ${theme.name}`}</title>
            </Helmet>

            <PageHeader header={<FormattedMessage id="header.checkout" defaultMessage="Checkout" />} breadcrumb={breadcrumb} />

            <div className="checkout block">
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-6 col-xl-7">
                            <div className="card mb-lg-0">
                                <div className="card-body">
                                    <h3 className="card-title">Shipping Details</h3>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="firstName">First name</label>
                                            <input
                                                id="firstName"
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter your first name"
                                                value={shippingInfo.firstName}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="lastName">Last name</label>
                                            <input
                                                id="lastName"
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter your last name"
                                                value={shippingInfo.lastName}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="companyName">
                                            Company Name <span className="text-muted">(Optional)</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="companyName"
                                            placeholder="Company Name"
                                            value={shippingInfo.companyName}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="country">Country</label>
                                            <input
                                                id="country"
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter your Country"
                                                value={shippingInfo.country}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="city">City</label>
                                            <input
                                                id="city"
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter your City"
                                                value={shippingInfo.city}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="shippingAddress1">Street Address</label>
                                            <input
                                                id="shippingAddress1"
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter your Address"
                                                value={shippingInfo.shippingAddress1}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="zip">Postal code</label>
                                            <input
                                                id="zip"
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter your Postal code"
                                                value={shippingInfo.zip}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="province" className="col-md-12 pr-0 pl-0">
                                            Province
                                            <select
                                                id="province"
                                                className="form-control"
                                                value={shippingInfo.province}
                                                onChange={handleChange}
                                            >
                                                <option value="AB">Alberta</option>
                                                <option value="BC">Colombie-Britannique</option>
                                                <option value="MB">Manitoba</option>
                                                <option value="NB">Nouveau-Brunswick</option>
                                                <option value="NL">Terre-Neuve-et-Labrador</option>
                                                <option value="NS">Nouvelle-Écosse</option>
                                                <option value="ON">Ontario</option>
                                                <option value="PE">Île-du-Prince-Édouard</option>
                                                <option value="QC">Québec</option>
                                                <option value="SK">Saskatchewan</option>
                                            </select>
                                        </label>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="appartement">Apartment, suite, unit etc. (Optional)</label>
                                        <input
                                            id="appartement"
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter your Apartment"
                                            value={shippingInfo.apartment}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="form-row">
                                        <div className="form-group col-md-6">
                                            <label htmlFor="phone">Phone</label>
                                            <input
                                                id="phone"
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter your phone"
                                                value={shippingInfo.phone}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label htmlFor="email">Email</label>
                                            <input
                                                id="email"
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter your email"
                                                value={shippingInfo.email}
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="card-divider" />
                            </div>
                        </div>

                        <div className="col-12 col-lg-6 col-xl-5 mt-4 mt-lg-0">
                            <div className="card mb-0">
                                <div className="card-body">
                                    <h3 className="card-title">Your Order</h3>

                                    {renderCart()}

                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-xl btn-block"
                                        onClick={handlePlaceOrder}
                                        disabled={loading}
                                    >
                                        {loading ? "Processing..." : "Place Order"}
                                    </button>
                                    {errorMessage && <div className="text-danger mt-3">{errorMessage}</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => ({
    cart: state.cart,
    user: state.user,
});

export default connect(mapStateToProps)(ShopPageCheckout);
